import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { pxToRem } from '../../assets/styles/helper';
import themeColors from '../../assets/styles/themeColors';

const DebugSettingsSearchContainer = styled.div`
  margin: ${pxToRem(32)} 0;
  padding: ${pxToRem(16)};
  border: 1px dashed ${themeColors.colorBorderPrimary};
  border-radius: ${pxToRem(4)};
`;

const DebugSettingsSearchTitle = styled.p`
  font-weight: 600;
  color: ${themeColors.colorTextPrimary};
  margin-bottom: ${pxToRem(12)};
`;

const DebugSettingsSearchInput = styled.input`
  width: 100%;
  max-width: ${pxToRem(400)};
  padding: ${pxToRem(8)} ${pxToRem(12)};
  border: 1px solid ${themeColors.colorBorderPrimary};
  border-radius: ${pxToRem(4)};
  margin-bottom: ${pxToRem(16)};
`;

const DebugSettingsSearchList = styled.ul`
  max-height: ${pxToRem(320)};
  overflow-y: auto;
  list-style: none;
  padding: 0;
  margin: 0;
`;

const DebugSettingsSearchRow = styled.li`
  display: flex;
  gap: ${pxToRem(8)};
  padding: ${pxToRem(4)} 0;
  border-bottom: 1px solid ${themeColors.colorBorderSecondary};
  font-size: ${pxToRem(13)};
  word-break: break-all;
`;

const DebugSettingsSearchKey = styled.span`
  font-weight: 600;
  color: ${themeColors.colorTextPrimary};
  white-space: nowrap;
`;

const DebugSettingsSearchValue = styled.span`
  color: ${themeColors.colorTextSecondary};
`;

const formatValue = (value) => {
  if (value === null || value === undefined) {
    return String(value);
  }
  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  return String(value);
};

const DebugSettingsSearch = ({ settings }) => {
  const [query, setQuery] = useState('');

  const settingsKeys = Object.keys(settings || {}).filter((key) =>
    key.toLowerCase().includes(query.toLowerCase()),
  );

  return (
    <DebugSettingsSearchContainer data-cy="debug-settings-search">
      <DebugSettingsSearchTitle>
        Debug: Search Settings ({Object.keys(settings || {}).length} total)
      </DebugSettingsSearchTitle>
      <DebugSettingsSearchInput
        type="text"
        placeholder="Search setting name..."
        value={query}
        onChange={(event) => setQuery(event.target.value)}
        data-cy="debug-settings-search-input"
      />
      <DebugSettingsSearchList>
        {settingsKeys.map((key) => (
          <DebugSettingsSearchRow key={key}>
            <DebugSettingsSearchKey>{key}:</DebugSettingsSearchKey>
            <DebugSettingsSearchValue>
              {formatValue(settings[key])}
            </DebugSettingsSearchValue>
          </DebugSettingsSearchRow>
        ))}
      </DebugSettingsSearchList>
    </DebugSettingsSearchContainer>
  );
};

DebugSettingsSearch.propTypes = {
  settings: PropTypes.objectOf(PropTypes.any),
};

DebugSettingsSearch.defaultProps = {
  settings: {},
};

export default DebugSettingsSearch;
